<template>
  <span>
    <v-list-item class="text-center">
      <v-btn
        :id="`${idPrefix}_MoveupIcon`"
        icon
        flat
        depressed
        fab
        @click="$emit('MoveUp')"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on, attr }">
            <v-icon class="material-icons-round" v-bind="attr" v-on="on">
              arrow_upward
            </v-icon>
          </template>
          <span>Move this card up</span>
        </v-tooltip>
      </v-btn>
    </v-list-item>

    <v-list-item class="text-center">
      <v-btn
        :id="`${idPrefix}_MoveDownIcon`"
        icon
        flat
        depressed
        fab
        @click="$emit('MoveDown')"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on, attr }">
            <v-icon class="material-icons-round" v-bind="attr" v-on="on">
              arrow_downward
            </v-icon>
          </template>
          <span>Move this card down</span>
        </v-tooltip>
      </v-btn>
    </v-list-item>
  </span>
</template>

<script>
export default {
  name: 'MoveCardUpDown',
  props: {
    idPrefix: {
      type: String,
      default: 'DashbooardCard_',
    },
  },
  methods: {},
};
</script>
